module.exports = __webpack_public_path__ + "img/do.c32f83f.svg";